import { Button, Grid, Typography } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add';
import React, { useState } from 'react'
import { ListSubAsset } from './ListSubAsset';
import { LinkNewAssetDialog } from './LinkNewAssetDialog';

export const LinkedSubAsset = () => {

    const [openDialog, setOpenDialog] = useState(false);


    const handleDialogOpen = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    return (

        <>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={1}
            >
                <Grid item xs={8}>
                    <Typography variant="h3">Linked Assets</Typography>
                </Grid>

                <Grid item xs={2}>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ textAlign: "right" }}
                        endIcon={<AddIcon />}
                        onClick={handleDialogOpen}>
                        Link New Asset
                    </Button>

                </Grid>
            </Grid>
            <ListSubAsset />


            <LinkNewAssetDialog
                open={openDialog}
                onClose={handleCloseDialog}
            />


        </>
    )
}


